import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import { AppLayout } from './Layout';
import { AuthGuard } from './auth/AuthGuard';
import { LoginPage } from './auth/LoginPage';
import { DashboardPage } from './pages/DashboardPage';
import { OrdersPage } from './pages/OrdersPage';
import { BalancesPage } from './pages/BalancesPage';
import { AuditPage } from './pages/AuditPage';
import { TransactionsPage } from './pages/TransactionsPage';
import { OrderDetailPage } from './pages/OrderDetailPage';
import { AdminUsersPage } from './pages/AdminUsersPage';
import { AdminChatsPage } from './pages/AdminChatsPage';
import { AdminRatesPage } from './pages/AdminRatesPage';
import { AdminApiPage } from './pages/AdminApiPage';
import { AdminTelegramPage } from './pages/AdminTelegramPage';
import { TelegramEventsPage } from './pages/TelegramEventsPage';
import { SecurityPage } from './pages/SecurityPage';
import { OrderDetailModal } from './components/modals/OrderDetailModal';
import { NewOrderModal } from './components/modals/NewOrderModal';

export function AppRoutes() {
  const location = useLocation();
  const background = (location.state as { backgroundLocation?: Location } | null)?.backgroundLocation;

  return (
    <>
      <Routes location={background ?? location}>
        <Route path="/login" element={<LoginPage />} />
        <Route
          path="/"
          element={
            <AuthGuard>
              <AppLayout />
            </AuthGuard>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<DashboardPage />} />
          <Route path="orders" element={<OrdersPage />} />
          <Route path="orders/new" element={<OrdersPage />} />
          <Route path="orders/:id" element={<OrderDetailPage />} />
          <Route path="balances" element={<BalancesPage />} />
          <Route path="audit" element={<AuditPage />} />
          <Route path="audit/:chatId" element={<AuditPage />} />
          <Route path="transactions" element={<TransactionsPage />} />
          <Route path="security" element={<SecurityPage />} />
          <Route path="admin/users" element={<AdminUsersPage />} />
          <Route path="admin/chats" element={<AdminChatsPage />} />
          <Route path="admin/rates" element={<AdminRatesPage />} />
          <Route path="admin/api" element={<AdminApiPage />} />
          <Route path="admin/telegram" element={<AdminTelegramPage />} />
          <Route path="admin/telegram/events" element={<TelegramEventsPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      {background && (
        <Routes>
          <Route path="/orders/new" element={<NewOrderModal />} />
          <Route path="/orders/:id" element={<OrderDetailModal />} />
        </Routes>
      )}
    </>
  );
}
